import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { Text } from 'Text';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    The mobile-only caption above the whole .course-information-box set. It uses a plain rule, not hr-hexagon
    (see SidebarBox).
*/
export const CourseInformationCaption: FC<{ className?: string }> = ({ className }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    return (
        <div id="course-information-caption" className={twMerge('md:hidden', className)}>
            <Text as="h2" className="mb-3 mt-0 text-center text-lg font-semibold leading-5 text-slate-grey">
                {t('course_information')}
            </Text>
            <hr className="mb-3 mt-0 border-t border-slate-grey-200" />
        </div>
    );
};
